import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Crown, Check } from "lucide-react";
import api from "@/lib/api";
import { PageHero, Loading } from "@/components/site/ui";
import { Reveal } from "@/components/brand";

export default function Membership() {
  const [levels, setLevels] = useState(null);
  useEffect(() => { api.get("/membership-levels").then((r) => setLevels(r.data.filter((l) => l.rank >= 0 && l.rank < 9))).catch(() => setLevels([])); }, []);
  return (
    <div>
      <PageHero eyebrow="Members Only" title="Membership at The D"
        subtitle="Membership deepens your access — earlier booking windows, complimentary touches, and a standing welcome." />
      <div className="max-w-7xl mx-auto px-6 py-20">
        {levels === null ? <Loading /> : (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {levels.map((l, i) => (
              <Reveal key={l.id} delay={(i % 3) * 0.08}>
                <div className="glass rounded-lg p-8 h-full hover:glow-gold transition-shadow duration-500" style={{ borderColor: `${l.color}55` }}>
                  <Crown size={22} style={{ color: l.color }} />
                  <h3 className="font-serif text-3xl mt-4">{l.name}</h3>
                  <div className="gold-line my-5" />
                  <ul className="space-y-3 text-sm text-muted-foreground">
                    {l.discount_percent > 0 && <li className="flex gap-2"><Check size={16} className="text-pool" /> {l.discount_percent}% member pricing</li>}
                    <li className="flex gap-2"><Check size={16} className="text-pool" /> {l.booking_window_days}-day booking window</li>
                    {l.complimentary_privileges && <li className="flex gap-2"><Check size={16} className="text-pool" /> Complimentary privileges</li>}
                    {!l.requires_approval && <li className="flex gap-2"><Check size={16} className="text-pool" /> Priority confirmation</li>}
                    <li className="flex gap-2"><Check size={16} className="text-pool" /> Digital membership card</li>
                  </ul>
                </div>
              </Reveal>
            ))}
          </div>
        )}
        <div className="text-center mt-16">
          <p className="text-muted-foreground">Membership is by invitation and host approval.</p>
          <Link to="/request-invitation" className="btn-gold inline-block px-8 py-3.5 text-sm mt-6">Request an Invitation</Link>
        </div>
      </div>
    </div>
  );
}
